import {Location} from './location';

export interface Flow {
  id: number;
  name: string;
  isActive?: boolean;
  isNative?: boolean;
  serviceId?: number;
  events?: EventType[]
}

export interface FlowCreate {
  "name": string,
  "isActive": boolean,
  "isNative": boolean,
  "serviceId"?: number
}

export interface FlowService {
  "id": number,
  "flowId": number,
  "serviceId": number,
}

export interface EventType {
  id: number;
  flowId?: number;
  name: string;
  eventClassId?: number;
  eventClass?: EventClass;
  isActive?: boolean;
  sequence: number;
  locationId?: number;
  eventTypeParentId?: number;
  events?: Event[];
  location?: Location
  eventTriggers?: EventTrigger[];
  mojitoDynamicField?: string;

  // Variables de front
  activator?: Activator
  icon?: string;
  color?: string;
}

export interface EventTypeCreate {
  name?: string,
  isActive?: boolean,
  sequence?: number,
  flowId?: number,
  eventClassId?: number,
  color?: string,
  icon?: string,
  mojitoDynamicField?: string;
}

export interface EventTriggerCreate {
  name?: string;
  integrationField?: string;
  eventTypeId?: number;
  documentUploaded?: boolean;
  documentValidation?: boolean;
  expirationDate?: string;
  eventTriggerTypeId?: number;
}

export interface EventTrigger {
  id: number;
  name?: string;
  integrationField?: string;
  eventTypeId?: number;
  documentUploaded?: boolean;
  documentValidation?: boolean;
  expirationDate?: string;
  eventTriggerTypeId?: number;
  eventTriggerType: {id: number, name: string};
  documentTypeId?: number;
  documentType?: {id: number, name: string}
}

export interface EventTriggerType{
  id: number;
  name: string;
}

export interface EventClass {
  id: number;
  name: string;
  isActive: boolean;
}

export interface Event {
  id: number;
  eventTypeId: number;
  serviceOrderId: number;
  locationId: number;
  dateTime: string;
  isActive: boolean;
  integrationField: string,
  integrationValue: string,
}

export interface EventCreate {
  "eventTypeId": number,
  "serviceOrderId": number,
  "locationId"?: number,
  "dateTime": string,
  "isActive": boolean,
}


export interface Activator {
  name: string;
  value: any; // Cualquier tipo de documento, cualquier estado de Mojito 360 o fecha manual
  location?: Location;
  mojitoDynamicField?: {enum: string, label: string};
}


